import { dropL, filterL, go, head, map, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleTouchMove = (self, event) => {
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const translate_transforming = self._getTranslateTransformingThrowable();
  const rotate_transforming = self._getRotateTransformingThrowable();
  const scale_transforming1 = self._getScaleTransforming1Throwable();
  const scale_transforming2 = self._getScaleTransforming2Throwable();
  if (self._touch_map.size <= 0) {
    return;
  }
  event.preventDefault();
  const { changedTouches: changed_touches, touches } = event;
  const changed_touch_map = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    mapL((touch) => [touch.identifier, touch]),
    (entries) => new Map(entries)
  );
  const touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(touches),
    mapL(({ identifier: id }) => id),
    (iter) => new Set(iter)
  );
  self._touch_map = go(
    self._touch_map.entries(),
    rejectL(([id]) => !touch_id_set.has(id)),
    mapL(([id, touch_pair]) => {
      const changed_touch = changed_touch_map.get(id);
      if (changed_touch == null) {
        return [id, touch_pair];
      }
      return [id, [touch_pair[0], changed_touch]];
    }),
    (entries) => new Map(entries)
  );
  switch (self._processing_task) {
    case PROCESSING_TASK.SELECTING: {
      if (self._selecting_touch_id == null) {
        return;
      }
      const touch = self._touch_map.get(self._selecting_touch_id)?.[1];
      if (touch == null) {
        return;
      }
      const { clientX: x, clientY: y } = touch;
      const rubber_band_layer_el_ctm = rubber_band_layer_el.getCTM();
      if (rubber_band_layer_el_ctm == null) {
        throw new Error(
          `rubber_band_layer 엘리먼트의 CTM 을 구할 수 없습니다.`
        );
      }
      const rubber_band_layer_el_ctm_inverse =
        rubber_band_layer_el_ctm.inverse();
      const point = self
        ._toViewPortPoint({
          x,
          y,
        })
        .matrixTransform(rubber_band_layer_el_ctm_inverse);
      rubber_band.progressSelecting({
        x: point.x,
        y: point.y,
      });
      return;
    }
    case PROCESSING_TASK.TRANSLATE_TRANSFORMING: {
      if (self._translate_transforming_touch_id == null) {
        return;
      }
      const touch = self._touch_map.get(
        self._translate_transforming_touch_id
      )?.[1];
      if (touch == null) {
        return;
      }
      const { clientX: client_x, clientY: client_y } = touch;
      translate_transforming.progress({
        x: client_x,
        y: client_y,
      });
      return;
    }
    case PROCESSING_TASK.ROTATE_TRANSFORMING: {
      if (self._rotate_transforming_touch_id == null) {
        return;
      }
      const touch = self._touch_map.get(
        self._rotate_transforming_touch_id
      )?.[1];
      if (touch == null) {
        return;
      }
      const { clientX: client_x, clientY: client_y } = touch;
      const point = self._toViewPortPoint({
        x: client_x,
        y: client_y,
      });
      rotate_transforming.progress({
        x1: self._rotate_transforming_origin_x,
        y1: self._rotate_transforming_origin_y,
        x2: point.x,
        y2: point.y,
      });
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING1: {
      if (self._scale_transforming1_touch_id == null) {
        return;
      }
      const touch = self._touch_map.get(
        self._scale_transforming1_touch_id
      )?.[1];
      if (touch == null) {
        return;
      }
      const { clientX: client_x, clientY: client_y } = touch;
      const point = self._toViewPortPoint({
        x: client_x,
        y: client_y,
      });
      scale_transforming1.progress({
        x: point.x,
        y: point.y,
      });
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING2: {
      if (self._scale_transforming2_touch_id1 == null) {
        return;
      }
      const touch1 = self._touch_map.get(
        self._scale_transforming2_touch_id1
      )?.[1];
      if (touch1 == null) {
        return;
      }
      const { clientX: client_x1, clientY: client_y1 } = touch1;
      const point1 = self._toViewPortPoint({
        x: client_x1,
        y: client_y1,
      });
      if (self._scale_transforming2_touch_id2 == null) {
        return;
      }
      const touch2 = self._touch_map.get(
        self._scale_transforming2_touch_id2
      )?.[1];
      if (touch2 == null) {
        return;
      }
      const { clientX: client_x2, clientY: client_y2 } = touch2;
      const point2 = self._toViewPortPoint({
        x: client_x2,
        y: client_y2,
      });
      scale_transforming2.progress({
        x1: point1.x,
        y1: point1.y,
        x2: point2.x,
        y2: point2.y,
      });
      return;
    }
    case null: {
      if (self._touch_map.size <= 0) {
        return;
      }
      if (self._touch_map.size === 1 && self._selected_el_ids.size <= 0) {
        const touch_pair_entry = go(
          self._touch_map.entries(),
          filterL(([touch_id]) => changed_touch_map.has(touch_id)),
          filterL(
            ([
              ,
              [{ clientX: x1, clientY: y1 }, { clientX: x2, clientY: y2 }],
            ]) =>
              Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2) > self._touch_margin
          ),
          head
        );
        if (touch_pair_entry == null) {
          return;
        }
        const [
          touch_id,
          [{ clientX: x1, clientY: y1 }, { clientX: x2, clientY: y2 }],
        ] = touch_pair_entry;
        const rubber_band_layer_el_ctm = rubber_band_layer_el.getCTM();
        if (rubber_band_layer_el_ctm == null) {
          throw new Error(
            `rubber_band_layer 엘리먼트의 CTM 을 구할 수 없습니다.`
          );
        }
        const rubber_band_layer_el_ctm_inverse =
          rubber_band_layer_el_ctm.inverse();
        const point1 = self
          ._toViewPortPoint({
            x: x1,
            y: y1,
          })
          .matrixTransform(rubber_band_layer_el_ctm_inverse);
        const point2 = self
          ._toViewPortPoint({
            x: x2,
            y: y2,
          })
          .matrixTransform(rubber_band_layer_el_ctm_inverse);
        rubber_band.startSelecting({
          x: point1.x,
          y: point1.y,
        });
        self._processing_task = PROCESSING_TASK.SELECTING;
        self._selecting_touch_id = touch_id;
        rubber_band.progressSelecting({
          x: point2.x,
          y: point2.y,
        });
        return;
      }
      if (self._touch_map.size === 1) {
        const touch = go(
          self._touch_map.entries(),
          filterL(([touch_id]) => changed_touch_map.has(touch_id)),
          mapL(dropL(1)),
          mapL(head),
          filterL(
            ([{ clientX: x1, clientY: y1 }, { clientX: x2, clientY: y2 }]) =>
              Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2) > self._touch_margin
          ),
          mapL(dropL(1)),
          mapL(head),
          head
        );
        if (touch == null) {
          return;
        }
        const { identifier: touch_id, clientX: x, clientY: y } = touch;
        const els = go(
          self._els.entries(),
          filterL(([id]) => self._selected_el_ids.has(id)),
          map(([, { wrapper_el }]) => wrapper_el)
        );
        if (els.length <= 0) {
          return;
        }
        translate_transforming.start({
          x: x,
          y: y,
          els,
        });
        self._processing_task = PROCESSING_TASK.TRANSLATE_TRANSFORMING;
        self._translate_transforming_touch_id = touch_id;
        return;
      }
      return;
    }
    default: {
      return;
    }
  }
};
